const EXTENSIONS_BY_GROUP: Record<string, string[]> = {
  "image/": [
    ".png",
    ".jpg",
    ".jpeg",
    ".gif",
    ".webp",
    ".bmp",
    ".svg",
    ".heic",
    ".heif",
    ".avif",
    ".tif",
    ".tiff",
    ".jfif",
    ".ico",
  ],
}

const EXTENSIONS_BY_MIME: Record<string, string[]> = {
  "application/pdf": [".pdf"],
}

export const isAcceptedFile = (file: File, acceptedTypes: readonly string[]): boolean => {
  if (acceptedTypes.length === 0) return true

  const filename = file.name.toLowerCase()
  const mimeType = file.type.toLowerCase()
  return acceptedTypes.some((acceptedType) => {
    const candidate = acceptedType.trim().toLowerCase()
    if (!candidate) return false
    if (candidate.startsWith(".")) return filename.endsWith(candidate)
    if (candidate.endsWith("/*")) {
      if (mimeType.startsWith(candidate.slice(0, -1))) return true
      if (mimeType) return false
      const group = candidate.slice(0, -1)
      return EXTENSIONS_BY_GROUP[group]?.some((ext) => filename.endsWith(ext)) ?? false
    }
    if (mimeType === candidate) return true
    if (mimeType) return false
    return EXTENSIONS_BY_MIME[candidate]?.some((ext) => filename.endsWith(ext)) ?? false
  })
}
